import { lazyLoad } from 'utils/loadable';

export const ImmersePage = lazyLoad(
  () => import('app/components/pages/ImmersePage/index'),
  (module) => module.ImmersePage,
);
